import { Component } from '@verndale/core';
import Cookies from 'js-cookie';
import { getTimesConfig, buildOptionsHtml } from '../helpers/times';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $topics: this.el._$('.community-contact-us__topics'),
      $communityInput: this.el._$('.community-contact-us__community input'),
      $form: this.el._$('.community-contact-us__form'),
      $communityZip: this.el._$('.community-contact-us__zip'),
      $contextCommunityInput: this.el._$(
        '.community-contact-us__community-context input'
      ),
      $communityDistance: this.el._$(
        '.community-contact-us__community-distance input'
      ),
      $datePicker: this.el._$('duet-date-picker'),
      $timeSelect: this.el._$('.community-contact-us__time select'),
      $communityColumns: this.el._$('.community-contact-us__cols'),
      $submitButton: this.el._$('.community-contact-us__submit')
    };
    this.preferredTimesTopicValue = this.el.dataset.preferredTimesTopic;
    this.preferredTimesShownClass = 'community-contact-us--preferred-times-shown';

    if (this.dom.$datePicker) {
      this.dom.$datePicker.firstDayOfWeek = 0;
      this.timeHandler();
    }

    this.metersToMiles = 0.000621371;

    this.verifyQueryParams();

    if (this.dom.$communityZip) {
      this.contextCommunity =
        Cookies.get('current_community') || this.el.dataset.contextCommunity;
    }
    this.fixMac();
  }

  fixMac() {
    if (navigator.userAgent.indexOf('Win') !== -1) {
      this.dom.$communityColumns?.classList.add('windows--screen');
    }
  }

  timeHandler() {
    this.dom.$timeSelect.innerHTML = '';
    const todayFormated = new Date()
      .toLocaleString('sv', {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
      .split(' ')[0]
      .split('/')
      .reverse()
      .join('-');
    const isToday = this.dom.$datePicker.value === todayFormated;
    const today = new Date().toLocaleString('en-US', {
      timeZone: 'America/New_York'
    });

    const { parsedOptions, minDatePicker } = getTimesConfig(
      this.dom.$datePicker,
      isToday,
      today
    );
    this.dom.$datePicker.min = minDatePicker;

    if (parsedOptions.length === 1) {
      const $dateInput =
        this.dom.$datePicker.querySelector('.duet-date__input');
      const errorMessage = this.dom.$datePicker.dataset.pristineNoTimes;
      setTimeout(() => {
        $dateInput.pristine.errors = [];
        $dateInput.pristine.self.addError($dateInput, errorMessage);
      });
    }

    const optionsHtml = buildOptionsHtml(parsedOptions);

    this.dom.$timeSelect.innerHTML = optionsHtml;
  }

  showZipError() {
    const zipCode = this.dom.$form.querySelector('[name="zipCode"]');
    const nearbyCommunitiesValue = this.dom.$form.querySelector(
      '[name="NearbyCommunities"]'
    )?.value;
    const contextCommunity = this.dom.$form.querySelector(
      '[name="ContextCommunity"]'
    )?.value;

    if (
      zipCode &&
      zipCode.value &&
      !nearbyCommunitiesValue &&
      !contextCommunity
    ) {
      zipCode.pristine.errors = [];
      zipCode.pristine.self.addError(zipCode, zipCode.dataset.errorMessage);
      return;
    }
  }

  setResults(results) {
    if (!results.length || results.length === 0) this.showZipError();
    this.dom.$contextCommunityInput.value =
      results[0] && results[0].raw ? results[0].raw.ssl_communityid : '';

    let inputValue = '';
    results.map((el, i) => {
      const id = el.raw.ssl_communityid;
      if (id && results.length - 1 !== i) {
        inputValue += `${id}, `;
      } else if (id) {
        inputValue += `${id}`;
      }
    });
    this.dom.$communityInput.setAttribute('value', inputValue);
    this.dom.$communityInput.value = inputValue;

    console.log('Context Community', this.contextCommunity);

    if (this.contextCommunity && results[0]) {
      this.dom.$communityDistance.value = (
        results[0].raw.distance * this.metersToMiles
      ).toFixed(2);
    } else if (!this.contextCommunity && results[0]) {
      console.log(
        'Results',
        results,
        (results[0].raw.distance * this.metersToMiles).toFixed(2)
      );
      this.dom.$communityDistance.value = (
        results[0].raw.distance * this.metersToMiles
      ).toFixed(2);
    }
  }

  addListeners() {
    if (this.dom.$topics) {
      this.dom.$topics._on('change', this.handleTopicChange.bind(this));
    }

    if (this.dom.$datePicker) {
      this.dom.$datePicker.addEventListener('duetChange', event => {
        this.currentDate = event.detail.valueAsDate;
        this.timeHandler();
      });

      this.dom.$datePicker.addEventListener('duetBlur', event => {
        const $input = this.dom.$datePicker.querySelector('input');
        const splited = this.dom.$datePicker.value.split('-');
        $input.value = `${this.checkZero(splited[1])}/${this.checkZero(
          splited[2]
        )}/${splited[0]}`;
      });
    }
  }

  checkZero(value) {
    if (value.split('')[0] === '0') return value.split('')[1];
    return value;
  }

  enableSubmitButton() {
    this.dom.$submitButton.classList.remove(
      'community-contact-us__submit--disabled'
    );
  }

  disableSubmitButton() {
    this.dom.$submitButton.classList.add(
      'community-contact-us__submit--disabled'
    );
  }

  resetSetup() {
    this.firstCommunity = false;
    this.isRadiusLarge = false;
    this.dom.$contextCommunityInput.value = '';
    this.dom.$communityInput.value = '';
    this.dom.$communityDistance.value = '';
  }

  verifyQueryParams() {
    const urlParams = new URLSearchParams(window.location.search);
    // IF BE sends query param book a tour true, scroll to the form and set the select option to book a tour
    if (urlParams.has('bookatour') && urlParams.get('bookatour') === 'true') {
      const yOffset = -40;
      const y =
        this.el.getBoundingClientRect().top + window.pageYOffset + yOffset;
      const select = this.dom.$topics.querySelector('select');
      const selectValuesToSearch = [
        'schedule-tour',
        'book-a-tour',
        'SCHEDULEVISIT'
      ];
      const e = new Event('change');

      window.scrollTo({ top: y, behavior: 'smooth' });

      [...select.options].forEach(option => {
        if (selectValuesToSearch.includes(option.value)) {
          select.value = option.value;
          select.dispatchEvent(e);
          this.handleTopicChange(e);
        }
      });
    }
  }

  handleTopicChange(e) {
    this.el.classList.toggle(
      this.preferredTimesShownClass,
      e.target.value === this.preferredTimesTopicValue
    );
  }
}

export default Module;
